var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import styles from './SeeMoreLess.module.scss';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
export var SeeMoreLess = function (props) {
    var _a, _b, _c;
    var label = props.label, children = props.children, headerChildren = props.headerChildren, _d = props.defaultOpen, defaultOpen = _d === void 0 ? false : _d, onHeaderClick = props.onHeaderClick;
    var _e = useState(defaultOpen), isContentOpen = _e[0], setIsContentOpen = _e[1];
    var handleOnLabelClick = function (e) {
        e.stopPropagation();
        setIsContentOpen(function (prev) { return !prev; });
        if (onHeaderClick) {
            onHeaderClick();
        }
    };
    var wrapperClass = classNames(styles.seeMoreLessWrapper, (_a = {}, _a[styles.seeMoreLessWrapperActive] = isContentOpen, _a), 'seemoreless-wrapper', { 'seemoreless-wrapper-active': isContentOpen });
    var labelWrapperClass = classNames(styles.seeMoreLessLabelWrapper, 'seemoreless-label-wrapper');
    var iconClass = classNames(styles.seeMoreLessIcon, (_b = {}, _b[styles.seeMoreLessIconActive] = isContentOpen, _b));
    var contentClass = classNames(styles.seeMoreLessContentWrapper, (_c = {}, _c[styles.seeMoreLessContentWrapperActive] = isContentOpen, _c), 'seemoreless-content');
    var labelComputed = label ? label : isContentOpen ? 'Voir moins' : 'Voir plus';
    return (_jsxs("div", __assign({ className: wrapperClass }, { children: [_jsx("div", __assign({ className: labelWrapperClass, onClick: handleOnLabelClick }, { children: headerChildren ? (headerChildren) : (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: styles.seeMoreLessLabel }, { children: labelComputed })), _jsx(Icons, { className: iconClass, icon: E_ICONS.ARROW_RIGHT })] })) })), children && (_jsx("div", __assign({ className: contentClass }, { children: _jsx("div", __assign({ className: styles.seeMoreLessContentRaw }, { children: children })) })))] })));
};
